<template>
  <div>
    <div class="d-flex align-center mb-8">
      <div>
        <img
          src="~@/v2/assets/images/download.png"
          class="doc-img"
        />
      </div>
      <div class="flex-grow-1 pl-4">
        <div class="font-weight-bold text-3xl">
          Congratulations on completing your will!
        </div>
      </div>
    </div>
    <div class="radius-4 overflow-hidden shadow-4">
      <v-list-item dense>
        <v-list-item-avatar
          color="bg-primary-10 radius-4"
          size="36"
        >
          <v-icon
            color="black"
            size="24"
            >mdi-file-document-outline</v-icon
          >
        </v-list-item-avatar>
        <v-list-item-content>
          <div class="font-weight-bold text-2xl">Your Will</div>
        </v-list-item-content>
        <v-list-item-action>
          <div class="text-center">
            <div
              v-if="originalPrice"
              class="original-price-will"
            >
              ${{ originalPrice }}
            </div>
            <h2 class="text-2xl">${{ willPrice }}</h2>
          </div>
        </v-list-item-action>
      </v-list-item>
      <div class="divider" />
      <div class="pa-2">
        <div
          v-for="(item, index) in features"
          :key="index"
        >
          <v-list-item
            dense
            class="feature-item"
          >
            <v-list-item-avatar
              class="mr-4 my-2"
              size="24"
              color="bg-white"
            >
              <v-icon
                color="primary"
                size="16"
                >mdi-check-bold</v-icon
              >
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <span class="">{{ item.label }}</span>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-list-item
          dense
          class="feature-item mb-2 mt-2"
        >
          <v-list-item-action class="pa-0 ma-0 mr-4">
            <v-chip
              color="primary"
              text-color="black"
              class="font-weight-bold"
              >BONUS</v-chip
            >
          </v-list-item-action>
          <v-list-item-content class="py-0">
            <span class="font-weight-bold"
              >Store information in your Digital Vault</span
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          dense
          class="feature-item mb-2"
        >
          <v-list-item-action class="pa-0 ma-0 mr-4">
            <v-chip
              color="primary"
              text-color="black"
              class="font-weight-bold"
              >BONUS</v-chip
            >
          </v-list-item-action>
          <v-list-item-content class="py-0">
            <span class="font-weight-bold">Make your Funeral Wishes known</span>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div class="bg-grey-20 d-flex align-center px-4 py-1">
        <v-spacer />
        <v-btn
          text
          small
          color="info"
          @click="openCode = true"
          >Apply code</v-btn
        >
      </div>
    </div>

    <div class="text-lg mb-2 mt-6 font-weight-bold">Add ons</div>
    <p class="mb-4">Click the options below that you would like to buy now.</p>
    <template v-if="addons.length > 0">
      <div class="mb-4 mt-4 font-weight-bold">For you</div>
      <checkout-add-on
        v-for="item in addons"
        :key="item.title"
        :title="item.title"
        :subtitle="item.subtitle"
        :info="item.info"
        :price="item.price"
        :price-from="item.priceFrom"
        :selected.sync="cart[item.product]"
        class="mb-4"
      />
    </template>

    <template v-if="hasPartner">
      <div class="mb-4 mt-4 font-weight-bold">For your partner</div>
      <checkout-add-on
        v-for="item in addonsPartner"
        :key="item.title"
        :title="item.title"
        :subtitle="item.subtitle"
        :info="item.info"
        :price="item.price"
        :price-from="item.priceFrom"
        :selected.sync="cart[item.product]"
        class="mb-4"
      />
      <p class="text-sm text-center">
        <strong>Note:</strong> After purchasing a Will or POA for your partner,
        we will send you a link to give to your partner so they can create their
        Willed account without needing to pay.
      </p>
    </template>

    <div class="text-center pb-4 pt-6">
      <v-btn
        v-bind="largeButton"
        :loading="loading"
        @click="goToCheckout()"
        ><template v-if="totalPrice === 0">Continue</template
        ><template v-else>Buy Now</template> (${{ totalPrice }})</v-btn
      >
      <v-img
        src="@/v2/assets/images/stripe-badge.png"
        width="340"
        class="d-block mx-auto mt-6"
      ></v-img>
    </div>
    <drawer
      :open.sync="openCode"
      title="Apply Discount"
    >
      <div class="pa-4">
        <form-discount-code
          v-if="openCode"
          @next="openCode = false"
          @close="openCode = false"
        />
      </div>
    </drawer>
    <drawer
      :open.sync="openCheckout"
      title="Payment"
    >
      <payment-checkout-new
        v-if="openCheckout"
        :items="selectedItems"
        :prepaid-code="appliedPrepaidCode"
        :promo-code="appliedPromoCode"
        :total="totalPrice"
      />
    </drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import CheckoutAddOn from "@/v2/layouts/checkout/components/AddOn.vue"

import { functions } from "../../../plugins/firebase"
import PaymentCheckoutNew from "../../components/checkout/PaymentCheckoutNew"
import FormDiscountCode from "../../components/form/DiscountCode"
import Drawer from "../../components/wrapper/Drawer"

export default {
  name: "CheckoutPurchase",
  components: { CheckoutAddOn, PaymentCheckoutNew, FormDiscountCode, Drawer },
  data: () => ({
    cart: {
      will: true,
      poa: false,
      partnerWill: false,
      partnerPoa: false,
      subscription: "plan_01",
    },
    addonsPartner: [
      {
        product: "partnerWill",
        title: "Partners Will",
        subtitle: "Buy now to save $80",
        info: null,
        price: 79,
        priceFrom: 159,
        selected: false,
        expanded: false,
      },
      {
        product: "partnerPoa",
        title: "Partners Powers of Attorney",
        subtitle: "Buy now to save $50",
        info: null,
        price: 49,
        priceFrom: 99,
        selected: false,
        expanded: false,
      },
    ],
    openCode: false,
    openCheckout: false,
    loading: false,
    features: [
      {
        label: "Your legally valid Will",
      },
      {
        label: "Unlimited changes for 1 year",
      },
      {
        label: "Download instantly",
      },
      {
        label: "Reviewed by our legal team on request",
      },
    ],
  }),
  mounted() {},
  methods: {
    async goToCheckout() {
      if (this.totalPrice > 0) {
        this.openCheckout = true
        return
      }

      this.loading = true

      await functions
        .httpsCallable("clientPurchaseProducts2")({
          uid: this.$store.getters["account/auth_user"].uid,
          items: this.selectedItems,
          promoCode: this.appliedPromoCode,
          prepaidCode: this.appliedPrepaidCode,
        })
        .then(async (resp) => {
          if (resp.data.status === "completed") {
            let query = {
              pt: "f",
              pd: 0,
              pn: this.selectedItems.map((o) => o.key).join("_"),
            }
            if (this.appliedPromoCode) {
              query.pc = this.appliedPromoCode
            }
            if (this.appliedPrepaidCode) {
              query.pp = this.appliedPrepaidCode
            }

            await this.$router.push({ path: "/", query: query })
          }
        })
        .catch((err) => {
          this.$store.commit("app/SET_MESSAGE", {
            type: "error",
            text: err,
          })
          this.loading = false
        })
    },
  },
  computed: {
    ...mapGetters("app", [
      "pricing",
      "referrer_discount_price",
      "discount_code",
    ]),
    ...mapGetters("account", ["user_partner", "user_access"]),
    addons() {
      let addons = []
      if (!this.user_access.hasPurchasedPoa) {
        addons.push({
          product: "poa",
          title: "Powers of Attorney",
          subtitle: "Buy now to save $50",
          price: this.pricing.products.poa.additional,
          priceFrom: this.pricing.products.poa.base,
          selected: false,
          expanded: false,
        })
      }
      return addons
    },
    hasPartner() {
      return this.user_partner?.value?.partnerId
    },
    willPrice() {
      if (this.discount_code) {
        return this.discount_code.price
      }
      if (this.referrer_discount_price !== null) {
        return this.referrer_discount_price
      }

      return this.pricing.products.will.base
    },
    originalPrice() {
      if (this.discount_code) {
        return this.discount_code.price < this.pricing.products.will.base
          ? this.pricing.products.will.base
          : false
      }

      return false
    },
    partnerPrice() {
      return this.pricing.products.will.additional
    },
    subscriptionPrice() {
      return this.pricing.subscriptions.plans[
        this.pricing.subscriptions.defaultPlan
      ].price
    },
    selectedItems() {
      let items = [
        {
          name: "Legal Will",
          key: "will",
          price: this.willPrice,
        },
      ]

      if (this.cart.poa) {
        items.push({
          name: "Power of Attorney",
          key: "poa",
          price: this.pricing.products.poa.additional,
        })
      }

      if (this.cart.partnerWill) {
        items.push({
          name: "Partner's Will",
          key: "partnerWill",
          price: this.pricing.products.will.additional,
        })
      }

      if (this.cart.partnerPoa) {
        items.push({
          name: "Partner's Power of Attorney",
          key: "partnerPoa",
          price: this.pricing.products.poa.additional,
        })
      }

      return items
    },
    appliedPrepaidCode() {
      return this.discount_code?.type === "prepaid"
        ? this.discount_code.code.trim().toUpperCase()
        : null
    },
    appliedPromoCode() {
      return this.discount_code?.type === "promocode"
        ? this.discount_code.code.trim().toUpperCase()
        : null
    },
    totalPrice() {
      return this.selectedItems.reduce((a, o) => {
        return a + o.price
      }, 0)
    },
  },
}
</script>

<style lang="scss">
.feature-item {
  min-height: 0px;
}

.doc-img {
  height: 70px;
  width: auto;
}

.original-price-will {
  text-decoration: line-through;
  font-size: 14px;
  margin-top: -2px;
  opacity: 0.7;
}
</style>
